import React from 'react';

import {
  AUTH_PATH,
  defaultConfiguration,
  getAuthUrl,
  getQualityManagementUrl,
  getTenant,
  getUserManagementUrl,
  getUserProfileUrl,
  getWebexParamsUrl,
  getWebexTokensUrl,
  getWorkforceManagementUrl,
  RuntimeConfiguration,
} from '../constants/integrationConstants';

export const ConfigurationContext = React.createContext(defaultConfiguration);

export const ConfigurationProvider: React.FC<React.PropsWithChildren<RuntimeConfiguration>> = ({ children, env }) => {
  let {
    tenant,
    authUrl,
    userProfileUrl,
    userManagementUrl,
    qualityManagementUrl,
    workforceManagementUrl,
    webexTokensUrl,
    webexParamsUrl,
    webexccApiUrl,
    msteamsApiUrl,
    zoomccApiUrl,
    webexCallingApiUrl,
  } = defaultConfiguration;

  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_TENANCY === 'single') {
    authUrl = `${process.env.REACT_APP_PROXY_SERVICE_TARGET_PROTOCOL}${process.env.REACT_APP_PROXY_SERVICE_TARGET_HOST}${AUTH_PATH}`;
  }

  if (process.env.NODE_ENV === 'production') {
    // needs to be reconsidered later on due to tenant is not as first part of domain name.
    [tenant] = getTenant(env);
    authUrl = getAuthUrl(env);
    qualityManagementUrl = getQualityManagementUrl();
    workforceManagementUrl = getWorkforceManagementUrl();
    userManagementUrl = getUserManagementUrl();
    userProfileUrl = getUserProfileUrl();
  }

  /**
   * Webex parameters can be configured in both, production and dev enviroment.
   */
  webexTokensUrl = getWebexTokensUrl(env, webexTokensUrl);
  webexParamsUrl = getWebexParamsUrl(env, webexParamsUrl);

  /**
   * Default API URLS
   */
  if (env?.webexccApiUrl) {
    webexccApiUrl = env.webexccApiUrl;
  }

  if (env?.zoomccApiUrl) {
    zoomccApiUrl = env.zoomccApiUrl;
  }

  if (env?.msteamsApiUrl) {
    msteamsApiUrl = env.msteamsApiUrl;
  }

  if (env?.webexCallingApiUrl) {
    webexCallingApiUrl = env.webexCallingApiUrl;
  }

  const value = {
    ...defaultConfiguration,
    authUrl,
    tenant,
    userProfileUrl,
    userManagementUrl,
    qualityManagementUrl,
    workforceManagementUrl,
    webexTokensUrl,
    webexParamsUrl,
    webexccApiUrl,
    msteamsApiUrl,
    zoomccApiUrl,
    webexCallingApiUrl,
  };

  return <ConfigurationContext.Provider value={value}>{children}</ConfigurationContext.Provider>;
};

export const ConfigurationConsumer = ConfigurationContext.Consumer;

export const useConfig = () => React.useContext(ConfigurationContext);
